// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: Isc1ACYDLI

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import { AntdTooltip } from "@plasmicpkgs/antd5/skinny/registerTooltip";
import SourceCategoryIcon from "../../SourceCategoryIcon"; // plasmic-import: a6Bcof-mnj/component
import TextInput from "../../TextInput"; // plasmic-import: 5gQXQ5PIHOg/component
import GlowingText from "../../GlowingText"; // plasmic-import: qxJZoN8JWK/component
import DragHandle from "../../DragHandle"; // plasmic-import: HUdJ1-BuRo/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicSectionHeader.module.css"; // plasmic-import: Isc1ACYDLI/css

import MenuIconIcon from "./icons/PlasmicIcon__MenuIcon"; // plasmic-import: 6ypUPjJsyj/icon
import SearchsvgIcon from "./icons/PlasmicIcon__Searchsvg"; // plasmic-import: rQjkwIrrF-2/icon
import IconsCloseIcon from "./icons/PlasmicIcon__IconsClose"; // plasmic-import: -dI1oop3LS/icon
import Edit24RegularIcon from "./icons/PlasmicIcon__Edit24Regular"; // plasmic-import: Y_g-OeXgGm/icon
import PenIconWithLinessvgIcon from "./icons/PlasmicIcon__PenIconWithLinessvg"; // plasmic-import: Frs_68L0hd/icon

createPlasmicElementProxy;

export type PlasmicSectionHeader__VariantMembers = {
  variant:
    | "_default"
    | "editMode"
    | "sectionSettings"
    | "editingTitle"
    | "creating"
    | "divider"
    | "unEditable";
  hideTitle: "hideTitle";
};
export type PlasmicSectionHeader__VariantsArgs = {
  variant?: SingleChoiceArg<
    | "_default"
    | "editMode"
    | "sectionSettings"
    | "editingTitle"
    | "creating"
    | "divider"
    | "unEditable"
  >;
  hideTitle?: SingleBooleanChoiceArg<"hideTitle">;
};
type VariantPropType = keyof PlasmicSectionHeader__VariantsArgs;
export const PlasmicSectionHeader__VariantProps = new Array<VariantPropType>(
  "variant",
  "hideTitle"
);

export type PlasmicSectionHeader__ArgsType = {
  sectionTitle?: React.ReactNode;
  line?: React.ReactNode;
};
type ArgPropType = keyof PlasmicSectionHeader__ArgsType;
export const PlasmicSectionHeader__ArgProps = new Array<ArgPropType>(
  "sectionTitle",
  "line"
);

export type PlasmicSectionHeader__OverridesType = {
  root?: p.Flex<"div">;
  sectionTitleContainer?: p.Flex<"div">;
  leftHandAction?: p.Flex<"button">;
  tooltip?: p.Flex<typeof AntdTooltip>;
  sourceCategoryIcon?: p.Flex<typeof SourceCategoryIcon>;
  save?: p.Flex<"div">;
  sourceCategoryIcon2?: p.Flex<typeof SourceCategoryIcon>;
  titleBox?: p.Flex<"div">;
  inputComponent?: p.Flex<typeof TextInput>;
  editTitle?: p.Flex<"button">;
  rightHandAction?: p.Flex<"button">;
  glowingText?: p.Flex<typeof GlowingText>;
  dragHandle?: p.Flex<typeof DragHandle>;
};

export interface DefaultSectionHeaderProps {
  sectionTitle?: React.ReactNode;
  line?: React.ReactNode;
  variant?: SingleChoiceArg<
    | "_default"
    | "editMode"
    | "sectionSettings"
    | "editingTitle"
    | "creating"
    | "divider"
    | "unEditable"
  >;
  hideTitle?: SingleBooleanChoiceArg<"hideTitle">;
  className?: string;
}

const $$ = {};

function PlasmicSectionHeader__RenderFunc(props: {
  variants: PlasmicSectionHeader__VariantsArgs;
  args: PlasmicSectionHeader__ArgsType;
  overrides: PlasmicSectionHeader__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "variant",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.variant
      },
      {
        path: "hideTitle",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hideTitle
      },
      {
        path: "inputComponent.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const [isRootHover, triggerRootHoverProps] = useTrigger("useHover", {});
  const triggers = {
    hover_root: isRootHover
  };

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.rootglobal_theme_dark_variant_editingTitle]:
            hasVariant($state, "variant", "editingTitle") &&
            hasVariant(globalVariants, "theme", "dark"),
          [sty.rootglobal_theme_dark_variant_sectionSettings]:
            hasVariant($state, "variant", "sectionSettings") &&
            hasVariant(globalVariants, "theme", "dark"),
          [sty.rootvariant__default]: hasVariant($state, "variant", "_default"),
          [sty.rootvariant_creating]: hasVariant($state, "variant", "creating"),
          [sty.rootvariant_divider]: hasVariant($state, "variant", "divider"),
          [sty.rootvariant_editMode]: hasVariant($state, "variant", "editMode"),
          [sty.rootvariant_editingTitle]: hasVariant(
            $state,
            "variant",
            "editingTitle"
          ),
          [sty.rootvariant_sectionSettings]: hasVariant(
            $state,
            "variant",
            "sectionSettings"
          )
        }
      )}
      data-plasmic-trigger-props={[triggerRootHoverProps]}
    >
      {(hasVariant($state, "variant", "divider") ? true : false)
        ? p.renderPlasmicSlot({
            defaultContents: null,
            value: args.line
          })
        : null}
      {(
        hasVariant($state, "variant", "divider")
          ? true
          : hasVariant($state, "variant", "creating")
          ? false
          : true
      ) ? (
        <p.Stack
          as={"div"}
          data-plasmic-name={"sectionTitleContainer"}
          data-plasmic-override={overrides.sectionTitleContainer}
          hasGap={true}
          className={classNames(projectcss.all, sty.sectionTitleContainer, {
            [sty.sectionTitleContainerglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.sectionTitleContainerglobal_theme_dark_variant_editingTitle]:
              hasVariant($state, "variant", "editingTitle") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.sectionTitleContainerglobal_theme_dark_variant_sectionSettings]:
              hasVariant($state, "variant", "sectionSettings") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.sectionTitleContainerhideTitle_variant__default]:
              hasVariant($state, "hideTitle", "hideTitle") &&
              hasVariant($state, "variant", "_default"),
            [sty.sectionTitleContainervariant__default]: hasVariant(
              $state,
              "variant",
              "_default"
            ),
            [sty.sectionTitleContainervariant_creating]: hasVariant(
              $state,
              "variant",
              "creating"
            ),
            [sty.sectionTitleContainervariant_divider]: hasVariant(
              $state,
              "variant",
              "divider"
            ),
            [sty.sectionTitleContainervariant_editMode]: hasVariant(
              $state,
              "variant",
              "editMode"
            ),
            [sty.sectionTitleContainervariant_editingTitle]: hasVariant(
              $state,
              "variant",
              "editingTitle"
            ),
            [sty.sectionTitleContainervariant_sectionSettings]: hasVariant(
              $state,
              "variant",
              "sectionSettings"
            )
          })}
        >
          <button
            data-plasmic-name={"leftHandAction"}
            data-plasmic-override={overrides.leftHandAction}
            className={classNames(
              projectcss.all,
              projectcss.button,
              sty.leftHandAction,
              {
                [sty.leftHandActionglobal_theme_dark_variant_editingTitle]:
                  hasVariant($state, "variant", "editingTitle") &&
                  hasVariant(globalVariants, "theme", "dark"),
                [sty.leftHandActionglobal_theme_dark_variant_sectionSettings]:
                  hasVariant($state, "variant", "sectionSettings") &&
                  hasVariant(globalVariants, "theme", "dark"),
                [sty.leftHandActionvariant_divider]: hasVariant(
                  $state,
                  "variant",
                  "divider"
                ),
                [sty.leftHandActionvariant_editMode]: hasVariant(
                  $state,
                  "variant",
                  "editMode"
                ),
                [sty.leftHandActionvariant_editingTitle]: hasVariant(
                  $state,
                  "variant",
                  "editingTitle"
                ),
                [sty.leftHandActionvariant_sectionSettings]: hasVariant(
                  $state,
                  "variant",
                  "sectionSettings"
                )
              }
            )}
            ref={ref => {
              $refs["leftHandAction"] = ref;
            }}
          >
            <AntdTooltip
              data-plasmic-name={"tooltip"}
              data-plasmic-override={overrides.tooltip}
              className={classNames("__wab_instance", sty.tooltip, {
                [sty.tooltipvariant_sectionSettings]: hasVariant(
                  $state,
                  "variant",
                  "sectionSettings"
                ),
                [sty.tooltipvariant_unEditable]: hasVariant(
                  $state,
                  "variant",
                  "unEditable"
                )
              })}
              titleText={"Tooltip contents"}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__amcO4,
                  {
                    [sty.textvariant_unEditable__amcO49XJtB]: hasVariant(
                      $state,
                      "variant",
                      "unEditable"
                    )
                  }
                )}
              >
                {"This text element is wrapped in a Tooltip component"}
              </div>
              {(
                hasVariant($state, "variant", "divider")
                  ? true
                  : hasVariant($state, "variant", "editingTitle")
                  ? false
                  : hasVariant($state, "variant", "sectionSettings")
                  ? false
                  : hasVariant($state, "variant", "editMode")
                  ? true
                  : true
              ) ? (
                <SourceCategoryIcon
                  data-plasmic-name={"sourceCategoryIcon"}
                  data-plasmic-override={overrides.sourceCategoryIcon}
                  className={classNames(
                    "__wab_instance",
                    sty.sourceCategoryIcon,
                    {
                      [sty.sourceCategoryIconglobal_theme_dark]: hasVariant(
                        globalVariants,
                        "theme",
                        "dark"
                      ),
                      [sty.sourceCategoryIconvariant__default]: hasVariant(
                        $state,
                        "variant",
                        "_default"
                      ),
                      [sty.sourceCategoryIconvariant_divider]: hasVariant(
                        $state,
                        "variant",
                        "divider"
                      ),
                      [sty.sourceCategoryIconvariant_editMode]: hasVariant(
                        $state,
                        "variant",
                        "editMode"
                      ),
                      [sty.sourceCategoryIconvariant_editingTitle]: hasVariant(
                        $state,
                        "variant",
                        "editingTitle"
                      ),
                      [sty.sourceCategoryIconvariant_sectionSettings]:
                        hasVariant($state, "variant", "sectionSettings"),
                      [sty.sourceCategoryIconvariant_unEditable]: hasVariant(
                        $state,
                        "variant",
                        "unEditable"
                      )
                    }
                  )}
                  hover={
                    hasVariant($state, "variant", "_default") &&
                    triggers.hover_root
                      ? true
                      : triggers.hover_root
                      ? true
                      : undefined
                  }
                />
              ) : null}
            </AntdTooltip>
            {(
              hasVariant($state, "variant", "editingTitle")
                ? true
                : hasVariant($state, "variant", "sectionSettings")
                ? true
                : false
            ) ? (
              <div
                data-plasmic-name={"save"}
                data-plasmic-override={overrides.save}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.save,
                  {
                    [sty.saveglobal_theme_dark]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    ),
                    [sty.saveglobal_theme_dark_variant_editingTitle]:
                      hasVariant($state, "variant", "editingTitle") &&
                      hasVariant(globalVariants, "theme", "dark"),
                    [sty.saveglobal_theme_dark_variant_sectionSettings]:
                      hasVariant($state, "variant", "sectionSettings") &&
                      hasVariant(globalVariants, "theme", "dark"),
                    [sty.savevariant_divider]: hasVariant(
                      $state,
                      "variant",
                      "divider"
                    ),
                    [sty.savevariant_editMode]: hasVariant(
                      $state,
                      "variant",
                      "editMode"
                    ),
                    [sty.savevariant_editingTitle]: hasVariant(
                      $state,
                      "variant",
                      "editingTitle"
                    ),
                    [sty.savevariant_sectionSettings]: hasVariant(
                      $state,
                      "variant",
                      "sectionSettings"
                    )
                  }
                )}
              >
                {hasVariant($state, "variant", "editingTitle")
                  ? "Save"
                  : hasVariant($state, "variant", "sectionSettings")
                  ? "Save"
                  : "SAVE"}
              </div>
            ) : null}
            {(
              hasVariant($state, "variant", "divider")
                ? false
                : hasVariant($state, "variant", "editMode")
                ? false
                : hasVariant($state, "variant", "_default")
                ? false
                : false
            ) ? (
              <MenuIconIcon
                className={classNames(projectcss.all, sty.svg__f0Ad4, {
                  [sty.svgvariant__default__f0Ad4ZE3Hm]: hasVariant(
                    $state,
                    "variant",
                    "_default"
                  ),
                  [sty.svgvariant_divider__f0Ad4Vd5Ui]: hasVariant(
                    $state,
                    "variant",
                    "divider"
                  ),
                  [sty.svgvariant_editMode__f0Ad4Vh2Ye]: hasVariant(
                    $state,
                    "variant",
                    "editMode"
                  )
                })}
                role={"img"}
              />
            ) : null}
            {(
              hasVariant($state, "variant", "unEditable")
                ? true
                : hasVariant($state, "variant", "divider")
                ? true
                : hasVariant($state, "variant", "editingTitle")
                ? false
                : hasVariant($state, "variant", "sectionSettings")
                ? false
                : hasVariant($state, "variant", "editMode")
                ? true
                : true
            ) ? (
              <SourceCategoryIcon
                data-plasmic-name={"sourceCategoryIcon2"}
                data-plasmic-override={overrides.sourceCategoryIcon2}
                className={classNames(
                  "__wab_instance",
                  sty.sourceCategoryIcon2,
                  {
                    [sty.sourceCategoryIcon2global_theme_dark]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    ),
                    [sty.sourceCategoryIcon2variant__default]: hasVariant(
                      $state,
                      "variant",
                      "_default"
                    ),
                    [sty.sourceCategoryIcon2variant_divider]: hasVariant(
                      $state,
                      "variant",
                      "divider"
                    ),
                    [sty.sourceCategoryIcon2variant_editMode]: hasVariant(
                      $state,
                      "variant",
                      "editMode"
                    ),
                    [sty.sourceCategoryIcon2variant_editingTitle]: hasVariant(
                      $state,
                      "variant",
                      "editingTitle"
                    ),
                    [sty.sourceCategoryIcon2variant_sectionSettings]:
                      hasVariant($state, "variant", "sectionSettings"),
                    [sty.sourceCategoryIcon2variant_unEditable]: hasVariant(
                      $state,
                      "variant",
                      "unEditable"
                    )
                  }
                )}
                hover={
                  hasVariant($state, "variant", "_default") &&
                  triggers.hover_root
                    ? true
                    : triggers.hover_root
                    ? true
                    : undefined
                }
              />
            ) : null}
          </button>
          <p.Stack
            as={"div"}
            data-plasmic-name={"titleBox"}
            data-plasmic-override={overrides.titleBox}
            hasGap={true}
            className={classNames(projectcss.all, sty.titleBox, {
              [sty.titleBoxglobal_theme_dark_variant_sectionSettings]:
                hasVariant($state, "variant", "sectionSettings") &&
                hasVariant(globalVariants, "theme", "dark"),
              [sty.titleBoxhideTitle]: hasVariant(
                $state,
                "hideTitle",
                "hideTitle"
              ),
              [sty.titleBoxhideTitle_variant__default]:
                hasVariant($state, "hideTitle", "hideTitle") &&
                hasVariant($state, "variant", "_default"),
              [sty.titleBoxvariant__default]: hasVariant(
                $state,
                "variant",
                "_default"
              ),
              [sty.titleBoxvariant_creating]: hasVariant(
                $state,
                "variant",
                "creating"
              ),
              [sty.titleBoxvariant_divider]: hasVariant(
                $state,
                "variant",
                "divider"
              ),
              [sty.titleBoxvariant_editMode]: hasVariant(
                $state,
                "variant",
                "editMode"
              ),
              [sty.titleBoxvariant_sectionSettings]: hasVariant(
                $state,
                "variant",
                "sectionSettings"
              )
            })}
          >
            {(
              hasVariant($state, "variant", "editingTitle")
                ? true
                : hasVariant($state, "variant", "sectionSettings")
                ? true
                : false
            ) ? (
              <TextInput
                data-plasmic-name={"inputComponent"}
                data-plasmic-override={overrides.inputComponent}
                aria-label={"Title Input"}
                aria-labelledby={""}
                className={classNames("__wab_instance", sty.inputComponent, {
                  [sty.inputComponentvariant_divider]: hasVariant(
                    $state,
                    "variant",
                    "divider"
                  ),
                  [sty.inputComponentvariant_editMode]: hasVariant(
                    $state,
                    "variant",
                    "editMode"
                  ),
                  [sty.inputComponentvariant_editingTitle]: hasVariant(
                    $state,
                    "variant",
                    "editingTitle"
                  ),
                  [sty.inputComponentvariant_sectionSettings]: hasVariant(
                    $state,
                    "variant",
                    "sectionSettings"
                  )
                })}
                context={"sectionHeader"}
                onChange={(...eventArgs) => {
                  p.generateStateOnChangeProp($state, [
                    "inputComponent",
                    "value"
                  ])((e => e.target?.value).apply(null, eventArgs));
                }}
                value={
                  p.generateStateValueProp($state, [
                    "inputComponent",
                    "value"
                  ]) ?? ""
                }
              />
            ) : null}
            {(
              hasVariant($state, "hideTitle", "hideTitle") &&
              hasVariant($state, "variant", "_default")
                ? false
                : hasVariant($state, "variant", "divider")
                ? true
                : hasVariant($state, "variant", "editingTitle")
                ? false
                : true
            )
              ? p.renderPlasmicSlot({
                  defaultContents: "Youtube -  Programming \u2328\ufe0f",
                  value: args.sectionTitle,
                  className: classNames(sty.slotTargetSectionTitle, {
                    [sty.slotTargetSectionTitleglobal_theme_dark]: hasVariant(
                      globalVariants,
                      "theme",
                      "dark"
                    ),
                    [sty.slotTargetSectionTitleglobal_theme_dark_variant_editingTitle]:
                      hasVariant($state, "variant", "editingTitle") &&
                      hasVariant(globalVariants, "theme", "dark"),
                    [sty.slotTargetSectionTitleglobal_theme_dark_variant_sectionSettings]:
                      hasVariant($state, "variant", "sectionSettings") &&
                      hasVariant(globalVariants, "theme", "dark"),
                    [sty.slotTargetSectionTitlehideTitle]: hasVariant(
                      $state,
                      "hideTitle",
                      "hideTitle"
                    ),
                    [sty.slotTargetSectionTitlehideTitle_variant__default]:
                      hasVariant($state, "hideTitle", "hideTitle") &&
                      hasVariant($state, "variant", "_default"),
                    [sty.slotTargetSectionTitlevariant__default]: hasVariant(
                      $state,
                      "variant",
                      "_default"
                    ),
                    [sty.slotTargetSectionTitlevariant_creating]: hasVariant(
                      $state,
                      "variant",
                      "creating"
                    ),
                    [sty.slotTargetSectionTitlevariant_divider]: hasVariant(
                      $state,
                      "variant",
                      "divider"
                    ),
                    [sty.slotTargetSectionTitlevariant_editMode]: hasVariant(
                      $state,
                      "variant",
                      "editMode"
                    ),
                    [sty.slotTargetSectionTitlevariant_editingTitle]:
                      hasVariant($state, "variant", "editingTitle"),
                    [sty.slotTargetSectionTitlevariant_sectionSettings]:
                      hasVariant($state, "variant", "sectionSettings")
                  })
                })
              : null}
            <button
              data-plasmic-name={"editTitle"}
              data-plasmic-override={overrides.editTitle}
              className={classNames(
                projectcss.all,
                projectcss.button,
                sty.editTitle,
                {
                  [sty.editTitlevariant__default]: hasVariant(
                    $state,
                    "variant",
                    "_default"
                  ),
                  [sty.editTitlevariant_divider]: hasVariant(
                    $state,
                    "variant",
                    "divider"
                  ),
                  [sty.editTitlevariant_editMode]: hasVariant(
                    $state,
                    "variant",
                    "editMode"
                  ),
                  [sty.editTitlevariant_editingTitle]: hasVariant(
                    $state,
                    "variant",
                    "editingTitle"
                  ),
                  [sty.editTitlevariant_sectionSettings]: hasVariant(
                    $state,
                    "variant",
                    "sectionSettings"
                  )
                }
              )}
              ref={ref => {
                $refs["editTitle"] = ref;
              }}
            >
              <p.PlasmicIcon
                PlasmicIconType={
                  triggers.hover_root
                    ? PenIconWithLinessvgIcon
                    : hasVariant($state, "variant", "sectionSettings")
                    ? PenIconWithLinessvgIcon
                    : Edit24RegularIcon
                }
                className={classNames(projectcss.all, sty.svg__bmHAm, {
                  [sty.svgvariant_sectionSettings__bmHAmyRb5U]: hasVariant(
                    $state,
                    "variant",
                    "sectionSettings"
                  )
                })}
                role={"img"}
              />
            </button>
          </p.Stack>
        </p.Stack>
      ) : null}
      {(hasVariant(globalVariants, "theme", "dark") ? true : false) ? (
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__ex4EO,
            {
              [sty.textglobal_theme_dark__ex4EOoIz4X]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              )
            }
          )}
        >
          {"See All"}
        </div>
      ) : null}
      <button
        data-plasmic-name={"rightHandAction"}
        data-plasmic-override={overrides.rightHandAction}
        className={classNames(
          projectcss.all,
          projectcss.button,
          sty.rightHandAction,
          {
            [sty.rightHandActionglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.rightHandActionglobal_theme_dark_variant_creating]:
              hasVariant($state, "variant", "creating") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.rightHandActionglobal_theme_dark_variant_editingTitle]:
              hasVariant($state, "variant", "editingTitle") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.rightHandActionglobal_theme_dark_variant_sectionSettings]:
              hasVariant($state, "variant", "sectionSettings") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.rightHandActionvariant__default]: hasVariant(
              $state,
              "variant",
              "_default"
            ),
            [sty.rightHandActionvariant_creating]: hasVariant(
              $state,
              "variant",
              "creating"
            ),
            [sty.rightHandActionvariant_divider]: hasVariant(
              $state,
              "variant",
              "divider"
            ),
            [sty.rightHandActionvariant_editMode]: hasVariant(
              $state,
              "variant",
              "editMode"
            ),
            [sty.rightHandActionvariant_editingTitle]: hasVariant(
              $state,
              "variant",
              "editingTitle"
            ),
            [sty.rightHandActionvariant_sectionSettings]: hasVariant(
              $state,
              "variant",
              "sectionSettings"
            )
          }
        )}
        ref={ref => {
          $refs["rightHandAction"] = ref;
        }}
      >
        <GlowingText
          data-plasmic-name={"glowingText"}
          data-plasmic-override={overrides.glowingText}
          className={classNames("__wab_instance", sty.glowingText, {
            [sty.glowingTextglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.glowingTextglobal_theme_dark_variant_creating]:
              hasVariant($state, "variant", "creating") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.glowingTextglobal_theme_dark_variant_editingTitle]:
              hasVariant($state, "variant", "editingTitle") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.glowingTextglobal_theme_dark_variant_sectionSettings]:
              hasVariant($state, "variant", "sectionSettings") &&
              hasVariant(globalVariants, "theme", "dark"),
            [sty.glowingTextvariant__default]: hasVariant(
              $state,
              "variant",
              "_default"
            ),
            [sty.glowingTextvariant_creating]: hasVariant(
              $state,
              "variant",
              "creating"
            ),
            [sty.glowingTextvariant_divider]: hasVariant(
              $state,
              "variant",
              "divider"
            ),
            [sty.glowingTextvariant_editMode]: hasVariant(
              $state,
              "variant",
              "editMode"
            ),
            [sty.glowingTextvariant_editingTitle]: hasVariant(
              $state,
              "variant",
              "editingTitle"
            ),
            [sty.glowingTextvariant_sectionSettings]: hasVariant(
              $state,
              "variant",
              "sectionSettings"
            )
          })}
          glow={
            hasVariant($state, "variant", "creating") &&
            hasVariant(globalVariants, "theme", "dark")
              ? "red"
              : hasVariant($state, "variant", "editingTitle") &&
                hasVariant(globalVariants, "theme", "dark")
              ? "red"
              : hasVariant($state, "variant", "sectionSettings") &&
                hasVariant(globalVariants, "theme", "dark")
              ? "red"
              : hasVariant(globalVariants, "theme", "dark")
              ? "blue"
              : undefined
          }
          variant={
            hasVariant($state, "variant", "divider")
              ? "editMode"
              : hasVariant($state, "variant", "creating")
              ? "creating"
              : hasVariant($state, "variant", "editingTitle") &&
                hasVariant(globalVariants, "theme", "dark")
              ? "editingTitle"
              : hasVariant($state, "variant", "editingTitle")
              ? "editingTitle"
              : hasVariant($state, "variant", "sectionSettings") &&
                hasVariant(globalVariants, "theme", "dark")
              ? "sectionSettings"
              : hasVariant($state, "variant", "sectionSettings")
              ? "sectionSettings"
              : hasVariant($state, "variant", "editMode")
              ? "editMode"
              : hasVariant($state, "variant", "_default")
              ? "_default"
              : undefined
          }
        />
      </button>
      <DragHandle
        data-plasmic-name={"dragHandle"}
        data-plasmic-override={overrides.dragHandle}
        className={classNames("__wab_instance", sty.dragHandle, {
          [sty.dragHandlevariant_divider]: hasVariant(
            $state,
            "variant",
            "divider"
          ),
          [sty.dragHandlevariant_editMode]: hasVariant(
            $state,
            "variant",
            "editMode"
          )
        })}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "sectionTitleContainer",
    "leftHandAction",
    "tooltip",
    "sourceCategoryIcon",
    "save",
    "sourceCategoryIcon2",
    "titleBox",
    "inputComponent",
    "editTitle",
    "rightHandAction",
    "glowingText",
    "dragHandle"
  ],
  sectionTitleContainer: [
    "sectionTitleContainer",
    "leftHandAction",
    "tooltip",
    "sourceCategoryIcon",
    "save",
    "sourceCategoryIcon2",
    "titleBox",
    "inputComponent",
    "editTitle"
  ],
  leftHandAction: [
    "leftHandAction",
    "tooltip",
    "sourceCategoryIcon",
    "save",
    "sourceCategoryIcon2"
  ],
  tooltip: ["tooltip", "sourceCategoryIcon"],
  sourceCategoryIcon: ["sourceCategoryIcon"],
  save: ["save"],
  sourceCategoryIcon2: ["sourceCategoryIcon2"],
  titleBox: ["titleBox", "inputComponent", "editTitle"],
  inputComponent: ["inputComponent"],
  editTitle: ["editTitle"],
  rightHandAction: ["rightHandAction", "glowingText"],
  glowingText: ["glowingText"],
  dragHandle: ["dragHandle"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  sectionTitleContainer: "div";
  leftHandAction: "button";
  tooltip: typeof AntdTooltip;
  sourceCategoryIcon: typeof SourceCategoryIcon;
  save: "div";
  sourceCategoryIcon2: typeof SourceCategoryIcon;
  titleBox: "div";
  inputComponent: typeof TextInput;
  editTitle: "button";
  rightHandAction: "button";
  glowingText: typeof GlowingText;
  dragHandle: typeof DragHandle;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSectionHeader__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSectionHeader__VariantsArgs;
    args?: PlasmicSectionHeader__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicSectionHeader__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicSectionHeader__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSectionHeader__ArgProps,
          internalVariantPropNames: PlasmicSectionHeader__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSectionHeader__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSectionHeader";
  } else {
    func.displayName = `PlasmicSectionHeader.${nodeName}`;
  }
  return func;
}

export const PlasmicSectionHeader = Object.assign(
  // Top-level PlasmicSectionHeader renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sectionTitleContainer: makeNodeComponent("sectionTitleContainer"),
    leftHandAction: makeNodeComponent("leftHandAction"),
    tooltip: makeNodeComponent("tooltip"),
    sourceCategoryIcon: makeNodeComponent("sourceCategoryIcon"),
    save: makeNodeComponent("save"),
    sourceCategoryIcon2: makeNodeComponent("sourceCategoryIcon2"),
    titleBox: makeNodeComponent("titleBox"),
    inputComponent: makeNodeComponent("inputComponent"),
    editTitle: makeNodeComponent("editTitle"),
    rightHandAction: makeNodeComponent("rightHandAction"),
    glowingText: makeNodeComponent("glowingText"),
    dragHandle: makeNodeComponent("dragHandle"),

    // Metadata about props expected for PlasmicSectionHeader
    internalVariantProps: PlasmicSectionHeader__VariantProps,
    internalArgProps: PlasmicSectionHeader__ArgProps
  }
);

export default PlasmicSectionHeader;
/* prettier-ignore-end */
